import React, { Component, Fragment } from 'react'
import './index.css'
import Helmet from 'react-helmet-async'
import withDsideApi from "../../../HOC/Fetch";
import withLanguage from "../../../HOC/withLanguage";
import {Link} from 'react-router-dom'
import CategoryItem from './CategoryItem';
import PortolioPost from '../Header__Post/Portfolio__Post';
import gsap from 'gsap'
import Arrow  from '../../Basic/Footer/arrow.svg';
import Ad  from '../Main/About__block/chess.png';
import Translate from "translate-components";
import Footer from '../../Basic/Footer';
import ScrollMagic from '../../scrollMagic';

class Portfolio extends Component {
  constructor(props) {
    super(props)

    this.state = {
      dataItems: [],
      dataItemsStatic: [],
      activeFilter: null,
      category: null,
    }
  }

  async componentDidMount() {
    console.log(this);
   window.scrollTo(0, 0);
      this.setFilteringCategoryNull();
  }

  setFilteringCategory = async (selectFilterId, category) => {
      await this.setState({
        activeFilter: selectFilterId,
        category: category
      });
      await this.getCategoryData();
  }

  setFilteringCategoryNull = async (selectFilterId, category) => {


      await this.setState({
        activeFilter: selectFilterId,
        category: category
      });
      await this.getCategoryDataNull();
  }
 isActiveCategory = (id) => {
   return this.state.activeFilter == id
 }

 getCategoryData = () => {

    return fetch(`${process.env.REACT_APP_API}/${this.props.language}/portfolio/getPortfolioItems/${this.state.category.tag}/`).then((response) => {
       return response.json()
     }).then((items) => {
      var tl = new gsap.timeline({paused: true});
        tl.clear(true);

        this.setState({dataItems: items});
        this.setState({dataItemsStatic: items});




        tl.pause(0);
        tl.kill();
        tl.clear();
        let trigger = '.postitem';
        tl
            .staggerFrom('.postitem', .3, { backgroundColor: 'transparent', autoAlpha: 0, ease: 'Power0.EaseIn'}, .15)
            .staggerFrom('.postanim', .5, {y: -180, autoAlpha: 0, opacity: 0, ease: 'Back.EaseIn'}, .25, "-=0.75");
        let controller = new ScrollMagic.Controller();
       let scene = new ScrollMagic.Scene({triggerElement: trigger, triggerHook: .7, reverse: false, offset: 0})
     .setTween(tl)
     .reverse(false)
            .addTo(controller);
                    tl.resume();

     })
 }
 getCategoryDataNull = () => {
    return fetch(`${process.env.REACT_APP_API}/${this.props.language}/portfolio/getPortfolioItems/`).then((response) => {
       return response.json()
     }).then((items) => {
      var tl = new gsap.timeline({paused: true});
      tl.clear(true);

      this.setState({dataItems: items});
      this.setState({dataItemsStatic: items});




      tl.pause(0);
      tl.kill();
      tl.clear();
      let trigger = '.postitem';
      tl
          .staggerFrom('.postitem', .3, { backgroundColor: 'transparent', opacity:0, ease: 'Power0.EaseIn'}, .15)
          .staggerFrom('.postanim', .5, {y: -180, autoAlpha: 0, opacity: 0, ease: 'Back.EaseIn'}, .25, "-=0.75");
      let controller = new ScrollMagic.Controller();
      let scene = new ScrollMagic.Scene({triggerElement: trigger, triggerHook: .7, reverse: false, offset: 0})
     .setTween(tl)
     .reverse(false)
          .addTo(controller);
       const postitems = document.querySelectorAll('.postitem');
         tl.resume();
     })
 }

 render() {
    return (
      <Fragment>

      <div>
        <section className="portfolio__items-category">
          <Helmet>
            <title>Dside Portfolio</title>
          </Helmet>
        <div className="wrapper-row">
        <h2><Translate>We'll make it best. They have already tried it.</Translate></h2>
          <div className="sorting__items-container">

            <div className="sorting__items-left">

              <div className="sortby__category">

                <ul className="portfolio-category__list">

               <li class="portfolio-category__item" onClick={this.setFilteringCategoryNull}><p class=""><Translate>Everything</Translate><sup>({this.state.dataItems.length})</sup></p></li>
    {this.props.dataDside.map((category, index) => {
                    return (
                  <CategoryItem
                  key={index}
                  {...this.state}
                  category={category}
                  isActiveCategory={this.isActiveCategory(index)}
                  onActiveFilteringCategory={this.setFilteringCategory.bind(this,index, category)}
                  {...this.props}/>

                  )
                })}
                </ul>

              </div>

            </div>
            <div className="sorting__items-right">
              <div className="sortby__type">
                <div className="portfolio-sort__title"><Translate>Sort by:</Translate></div>

                <div className="sorting-portfolio__wrapper">
                  {/* <div className="portfolio-sorting__date">Date</div> */}

                  <div className="portfolio-sorting__date"><Translate>Category</Translate></div>
                </div>
              </div>
            </div>
</div>
          </div>
          <div className="portfolio__items-container">
              {this.props.loading ? (
                <PortolioPost {...this.props} dataDside={this.state.dataItems} />
              ) : null}
          </div>
            <div className="row">
           <div className="advantages">
             <div className="advantage-item right">
                        <div className="advitem-image-holder small rodrigo">
                            <img src={Ad} width={460} className="a2"/>

                        </div>
                        <div className="advitem-inner right">
                            <div className="adv-heading a2"><Translate>Did you enjoy our portfolio?</Translate></div>
                            <div className="adv-text a2"><Translate>It's time to calculate the approximate cost of your project. To calculate the exact cost, please leave a request through the 'Order' form, or using the price calculator.</Translate></div>
                            <Link className="adv-btn a2" to={`/${localStorage.getItem('lang')}/pricing`}><Translate>Calculate</Translate><img src={Arrow} width={16} alt=""/></Link>
                        </div>
                    </div>
            </div>
           </div>
        </section>
        <Footer/>
      </div>
      </Fragment>
    )
  }
}

export default withLanguage(withDsideApi(Portfolio, '/portfolio/getAllCategories/', null))



// WEBPACK FOOTER //
// ./src/components/DynamicContent/Portfolio/index.js